{
  "serviceCatalogRu": [
    {
      "element": "#service-catalog-1",
      "intro": "Поздравляем! Вы можете создать запрос в IT подразделение одним из предложенных вариантов"
    },
    {
      "element": "#service-catalog-2",
      "intro": "Быстрый поиск нужной вам услуги. Быстрое решение простых инцидентов соответствующими решениями в базе знаний. База знаний - вкладка на панели раздел обучение"
    },
    {
      "element": "#service-catalog-3",
      "intro": "Перейдите на Каталог услуг. Для просмотра доступных категорий услуг, выберите нужный вам сервис и услуги, проверить имеющиеся в ней шаблоны.\nВыберите нужный шаблон, чтобы открыть форму создания нового запроса"
    },
    {
      "element": "#info-panel-step-1",
      "intro": "Щелкните значок, чтобы просмотреть информацию о существующих проблемах в работе IT сервисов. Новейшие оповещения отображаются вверху списка"
    },
    {
      "element": "#info-panel-step-2",
      "intro": "На вкладке 'Заявки' представлены все ваши текущие заявки и инциденты. Все открытые запросы и инциденты отображаются в списке >> 'Заявки' Щелкните на тему любого запроса, чтобы просмотреть его детали, также вы можете выполнить поиск заявки по телефону или по дате создания"
    },
    {
      "element": "#info-panel-step-3",
      "intro": "Создание нового обращения к команде IT подразделения, когда требуется IT поддержка или услуга, такая как установка программного обеспечения или предоставления полномочий в информационной системе"
    }
  ]
}
